import React from 'react';
import RealPlayView from '../Components/RealPlayView/RealPlayView';
import { Redirect } from 'react-router-dom';
import { useShouldShowRealPlaysPage } from '../RealPlaysHook';
const Realplay = () => {
  const { loading, enabled: isEnabled } = useShouldShowRealPlaysPage();

  if (loading) return null;

  return isEnabled ? <RealPlayView /> : <Redirect to="/" />;
};

export default Realplay;
